import { Subject } from 'rxjs';
import { AppError } from '../util/error-utils';

export enum TYPE_ERROR {
  GLOBAL = 'global',
  STEP = 'step'
}

export interface IMessage {
  type: TYPE_ERROR;
  error: AppError;
}

export const globalError = new Subject<IMessage>();
